import { useCallback } from 'react'
import { useAppDispatch, useAppSelector } from 'src/store'
import { createUserTreatment } from 'src/useCase/userTreatment'
import appActions from 'src/store/ui/app'

export default function useCreateTreatment() {
  const dispatch = useAppDispatch()
  const userInfo = useAppSelector((state) => state.ui.app.authInfo)

  const createTreatment = useCallback(
    async (
      menuId: number,
      planId: number | string | null,
      userTreatmentForm: any,
    ) => {
      try {
        const newUserTreatment = await dispatch(
          createUserTreatment({
            data: { menu_id: menuId, plan_id: planId },
            form: userTreatmentForm,
          }),
        ).unwrap()

        if (userInfo) {
          const userTreatments = [...(userInfo.user_treatments || [])]
          const idx = userTreatments.findIndex(
            (ut) => ut.id === newUserTreatment.id,
          )

          if (idx !== -1) {
            userTreatments.splice(idx, 1, newUserTreatment)
          } else {
            userTreatments.push(newUserTreatment)
          }

          const newUser = {
            ...userInfo,
            user_treatments: [...userTreatments],
          }

          dispatch(appActions.updateAuthInfo(newUser))
        }

        return newUserTreatment
      } catch (e) {
        return null
      }
    },
    [dispatch, userInfo],
  )

  return { createTreatment }
}
